<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2 px-2">

        <b-col
          cols="12"
          md="9"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_search"
            >
              <strong>
                Search
              </strong>
            </label>
            <b-input
              id="filter_search"
              v-model="tableCategories.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_type"
            >
              <strong>
                Type
              </strong>
            </label>
            <b-select
              id="filter_type"
              v-model="filter.type"
              :options="filterTypes"
              :disabled="state.busy || fetching.types"
              @change="onRefreshTableCategories"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1"
        >
          <b-button
            type="button"
            variant="primary"
            @click="onShowAddFormCategory"
          >
            Add Category
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="tableCategories"
        hover
        responsive
        show-empty
        class="mt-2"
        :per-page="tableCategories.perPage"
        :current-page="tableCategories.currentPage"
        :items="myProvider"
        :fields="tableCategories.fields"
        :sort-by.sync="tableCategories.sortBy"
        :sort-desc.sync="tableCategories.sortDesc"
        :sort-direction="tableCategories.sortDirection"
        :filter="tableCategories.filter"
        :filter-included-fields="tableCategories.filterOn"
      >
        <template #cell(index)="row">
          {{ tableCategories.currentPage * tableCategories.perPage - tableCategories.perPage + (row.index + 1) }}
        </template>

        <template #cell(active)="row">
          {{ row.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(is_parent)="row">
          {{ row.item.is_parent == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(is_package)="row">
          {{ row.item.is_package == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(category_name)="row">
          <div class="text-nowrap">
            <strong>{{ row.value }}</strong>
          </div>
        </template>

        <template #cell()="row">
          <div class="text-nowrap">
            {{ row.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditFormCategory(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableCategories.perPage"
              :options="tableCategories.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableCategories.currentPage"
            :total-rows="tableCategories.totalRows"
            :per-page="tableCategories.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-category"
      scrollable
      no-close-on-backdrop
      :title="modalCategoryTitle"
      aria-hidden="false"
      @ok="onValidateFormCategory"
    >
      <ValidationObserver
        ref="formCategory"
      >
        <form
          novalidate
        >
          <ValidationProvider
            #default="{ errors }"
            name="type"
            vid="type"
            rules="required"
          >
            <b-form-group>
              <label for="type">
                <strong>
                  Type
                </strong>
              </label>
              <b-form-select
                id="type"
                v-model="category.type"
                :options="list.types"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy || fetching.types"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- select type --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="category name"
            vid="category_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label for="category_name">
                <strong>
                  Category
                </strong>
              </label>
              <b-input
                id="category_name"
                v-model="category.category_name"
                type="text"
                autocomplete="off"
                placeholder="enter category name"
                :state="errors.length > 0 ? false : null"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="maximum slot"
            vid="maximum_slot"
            rules="required|min:1"
          >
            <b-form-group>
              <label for="maximum_slot">
                <strong>
                  Max Slot or Quantity
                </strong>
              </label>
              <b-input
                id="maximum_slot"
                v-model="category.maximum_slot"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter maximum slot"
                min="1"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="is_parent"
              v-model="category.is_parent"
              name="is_parent"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Parent?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="is_package"
              v-model="category.is_package"
              name="is_package"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Package?
            </b-form-checkbox>
          </div>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="category.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AdminCategoryService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminCategory',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Categories'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        types: false
      },
      filter: {
        type: 'All'
      },
      list: {
        types: []
      },
      category: {
        id: null,
        type: null,
        category_name: null,
        maximum_slot: 1,
        is_parent: 0,
        is_package: 0,
        active: 0
      },
      tableCategories: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'type.type_name', label: 'type' },
          { key: 'category_name', label: 'category', sortable: true },
          { key: 'maximum_slot', class: 'text-center' },
          { key: 'is_parent', label: 'parent', class: 'text-center' },
          { key: 'is_package', label: 'package', class: 'text-center' },
          { key: 'active', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalCategoryTitle () {
      return this.state.editing ? 'Edit Category' : 'Add Category'
    },

    filterTypes () {
      return [{ text: 'All', value: 'All' }].concat(this.list.types)
    }
  },

  mounted () {
    core.index()
    this.getTypes()
  },

  methods: {

    async myProvider (ctx) {
      return await AdminCategoryService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter,
          filter_type: this.filter.type
        })
      ).then(({ data }) => {
        this.tableCategories.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        return []
      })
    },

    async getTypes () {
      this.fetching.types = true
      await SharedListService.getTypes().then(({ data }) => {
        this.list.types = data.map(({ id, type_name }) => ({
          text: type_name,
          value: id
        }))
        this.fetching.types = false
      })
    },

    onRefreshTableCategories () {
      this.$refs.tableCategories.refresh()
    },

    onShowAddFormCategory () {
      this.state.editing = false
      this.category.id = null
      this.category.type = null
      this.category.category_name = null
      this.category.maximum_slot = 0
      this.category.is_parent = 0
      this.category.is_package = 0
      this.category.active = 1
      this.$bvModal.show('modal-category')
    },

    onShowEditFormCategory (category) {
      this.state.editing = true
      this.category.id = category.id
      this.category.type = category.type_id
      this.category.category_name = category.category_name
      this.category.maximum_slot = category.maximum_slot
      this.category.is_parent = category.is_parent
      this.category.is_package = category.is_package
      this.category.active = category.active
      this.$bvModal.show('modal-category')
    },

    async onValidateFormCategory (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formCategory.validate().then(async success => {
        if (success) {
          let text = 'Do you really want to create category?'
          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.onPutFormCategory()
              } else {
                return this.onPostFormCategory()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            }
          )
        }
      })
    },

    async onPostFormCategory () {
      return new Promise(resolve => {
        AdminCategoryService.post(this.category).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-category')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.tableCategories.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formCategory.setErrors(error.message)
          resolve(error)
        })
      })
    },

    async onPutFormCategory () {
      return new Promise(resolve => {
        AdminCategoryService.put(this.category).then(({ data }) => {
          this.$bvModal.hide('modal-category')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableCategories.localItems, { id: data.category.id })
            row.type = data.category.type
            row.type_id = data.category.type.id
            row.category_name = data.category.category_name
            row.is_parent = data.category.is_parent
            row.is_package = data.category.is_package
            row.active = data.category.active
            row.updated_at = data.category.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formCategory.setErrors(error.message)
          resolve(error)
        })
      })
    }
  }
}
</script>
